import { KeyValue } from '@/main/models/common';
import {
  QuoteImportStatusTypes,
  QuoteImportStatusActionTypes
} from './quoteImportStatusTypes';

export function getQuoteImportStatus(): QuoteImportStatusActionTypes {
  return {
    type: QuoteImportStatusTypes.GET_QUOTE_IMPORT_STATUS
  };
}

export function saveQuoteImportStatus(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): QuoteImportStatusActionTypes {
  return {
    type: QuoteImportStatusTypes.SAVE_QUOTE_IMPORT_STATUS,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerQuoteImportStatus(): QuoteImportStatusActionTypes {
  return {
    type: QuoteImportStatusTypes.RESET_REDUCER_QUOTE_IMPORT_STATUS
  };
}

